import React, { useState } from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { NavLink } from "react-router-dom";
import { request_status_response, request_status_tableData } from "../../constants/apiEndpoints";
import { ProgressSpinner } from 'primereact/progressspinner';
import '../../assets/styles/main.css';
import progresspic from '../../assets/progress.png'
import styles from './RequestStatus.module.css'

const formatDate = (date) => {
    return new Date(date).toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
        timeZone: 'Asia/Kolkata',
    })
}

const formatHeader = (key) =>
    key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

const tableColumns = [
    "acknowledgement_no",
    //   "amount",
    //   "disputed_amount",
    //   "district",
    "payer_account_number",
    "payer_bank",
    "layer",
    //   "mode_of_payment",
    //   "payer_bank_code",
    //   "payer_mobile_number",
    //   "requestor",
    //   "rrn",
    //   "state",
    //   "sub_category",
    "transaction_date",
    "transaction_time",
    //"status"
    //   "transaction_type",
    //   "wallet",
];

const StatusBodyTemplate = (rowData) => {
    if (rowData.status === "Close" || rowData.status === "Closed") {
        return (
            <span className="flex align-items-center">
                <span
                    className={`${styles.status_icon} ${styles.green_color}`}
                >
                    <svg width="8" height="8" viewBox="0 0 16 16">
                        <polyline
                            points="3,9 7,13 13,4"
                            fill="none"
                            stroke="#fff"
                            strokeWidth="2"
                        />
                    </svg>
                </span>
                Closed
            </span>
        );
    } else if (rowData.status === "Open" || rowData.status === "Opened") {
        <span className="flex align-items-center">
            <span
                className={`${styles.status_icon} ${styles.green_color}`}
            >
                <svg width="8" height="8" viewBox="0 0 16 16">
                    <rect x="4" y="7" width="8" height="2" fill="#fff" rx="1" />
                </svg>
            </span>
            Open
        </span>
    } else if (rowData.status === "In Progress") {
        <span className="flex align-items-center">
            <img src={progresspic} height="15" width="15" className='mr-2' />
            In Progress
        </span>
    }
    return (
        <span className="flex align-items-center">
            <span
                className={`${styles.status_icon} ${styles.red_color}`}
            >
                <svg width="10" height="10" viewBox="0 0 16 16">
                    <path d="M4 4 L12 12 M4 12 L12 4" stroke="#fff" strokeWidth="2" />
                </svg>
            </span>
            {rowData.status}
        </span>
    );
};

export default function RequestStatus() {
    // const rowHeight = 40;
    // const visibleRows = 11;
    // const scrollHeight = `${rowHeight * visibleRows}px`;

    const [selectedAckNo, setSelectedAckNo] = useState(null);
    const [displayDialog, setDisplayDialog] = useState(false);
    const [mainMessage, setMainMessage] = useState(false);

    // Main table fetch
    const fetchRequests = async () => {
        const res = await axios.get(`${request_status_tableData}`);
        return (
            res.data?.message
            // ?.map((item, idx) => ({
            //     ...item,
            //     status: idx % 2 === 0 ? "Close" : "Open",
            // })) || []
        );
    };

    const {
        data: mainData = [],
        isLoading,
        isError,
        error,
    } = useQuery({
        queryKey: ["requests"],
        queryFn: fetchRequests,
        staleTime: 60 * 1000,
    });

    const [rootDetailsRes, setRootDetailsRes] = useState('')

    // Detail fetch
    const fetchRequestDetails = async (ackNo) => {
        // const payload = {
        //     "acknowledgement_no": ackNo
        // }
        const res = await axios.get(`${request_status_response}?acknowledgement_no=${ackNo}`);
        const item = res.data?.message?.[0];
        if (!item) return [];

        // Root fields you asked to include
        const rootDetails = {
            created_time: item.created_time,
            disputed_amount: item.disputed_amount,
            hold_amount: item.hold_amount,
            job_id: item.job_id,
        };
        setRootDetailsRes(rootDetails)

        if (item.transaction_details[0].message) {
            setMainMessage(item.transaction_details[0].message)
            return;
        }
        // Map transaction_details into rows
        return (item.transaction_details || []).map((tx) => ({
            // ...rootDetails,
            // payee_account_number: tx.payee_account_number,
            // payee_bank_code: tx.payee_bank_code,
            // payee_bank_name: tx.payee_bank_name,
            // payee_ifsc_code: tx.payee_ifsc_code,
            // root_account_number: tx.root_account_number,
            // root_bank_id: tx.root_bank_id,
            // root_bank_name: tx.root_bank_name,
            // root_email: tx.root_email,
            // root_full_name: tx.root_full_name,
            // root_phone: tx.root_phone,
            // rrn: tx.rrn,
            amount: tx.amount,
            description: tx.description,
            disputed_amount: tx.disputed_amount,
            email: tx.email,
            IFSC_code: tx.ifsc_code,
            PAN_number: tx.pan_number,
            // time: tx.created_at,
            payee_bank: tx.payee_bank,
            payee_bank_account_number: tx.payee_bank_account_number,
            payee_bank_code: tx.payee_bank_code,
            phone_number: tx.phone_number,
            remarks: tx.remarks ? tx.remarks : '-',
            root_account_number: tx.root_account_number,
            root_bank_id: tx.root_bank_id,
            root_effective_balance: tx.root_effective_balance,
            //root_ifsc_code: tx.root_ifsc_code,
            root_rrn_transaction_id: tx.root_rrn_transaction_id,
            transaction_type: tx.txn_type,
            transaction_time: tx.transaction_datetime,
            //transaction_id: tx.transaction_id,
            //UPI_id: tx.upi_id,
            status: tx.status_code,
        }));
    };

    const {
        data: detailData = [],
        isLoading: isDetailLoading,
    } = useQuery({
        queryKey: ["requestDetails", selectedAckNo],
        queryFn: () => fetchRequestDetails(selectedAckNo),
        enabled: !!selectedAckNo,
    });

    // Click for ack number in main table
    const RequestorIDBodyTemplate = (rowData) => {
        if (rowData.status === "Close" || rowData.status === "Closed") {
            return (
                <NavLink
                    to="#"
                    style={{ color: "#007ad9", cursor: "pointer", textDecoration: "none" }}
                    onClick={(e) => {
                        e.preventDefault();
                        setSelectedAckNo(rowData.acknowledgement_no);
                        setDisplayDialog(true);
                    }}
                >
                    {rowData.acknowledgement_no}
                </NavLink>
            );
        } else {
            return <span>{rowData.acknowledgement_no}</span>;
        }
    };

    return (
        <div
            className="card"
            style={{
                marginTop: "20px",
                marginLeft: "20px",
                marginRight: "20px",
                marginBottom: "0px",
                paddingBottom: "0px",
            }}
        >
            {isLoading && <div className="centered-container flex justify-content-center align-items-center">
                <ProgressSpinner className="custom-spinner" strokeWidth="4" animationDuration=".9s" />
            </div>}
            {isError && <p style={{ color: "red" }}>Error: {error.message}</p>}

            {!isLoading && !isError && (
                <DataTable
                    value={mainData}
                    paginator
                    rows={10}
                    rowsPerPageOptions={[5, 10, 15, 20]}
                    scrollable
                    scrollHeight={"70vh"}
                    responsiveLayout="scroll"
                >
                    {/* Clickable first column */}
                    <Column
                        field="acknowledgement_no"
                        header={formatHeader("acknowledgement_no")}
                        body={RequestorIDBodyTemplate}
                    />

                    {tableColumns
                        .filter((key) => key !== "acknowledgement_no")
                        .map((key) => (
                            <Column key={key} field={key} header={formatHeader(key)} />
                        ))}

                    <Column field="status" header="Status" body={StatusBodyTemplate} />
                </DataTable>
            )}

            {/* Modal */}
            <Dialog
                header={`Requestor Details: ${selectedAckNo || ""}`}
                visible={displayDialog}
                style={{ width: "90vw" }}
                modal
                onHide={() => {
                    setDisplayDialog(false);
                    setSelectedAckNo(null);
                }}
                closeOnEscape
            >
                {isDetailLoading ? (
                    <div className="centered-dialog-container flex justify-content-center align-items-center">
                        <ProgressSpinner className="custom-spinner" strokeWidth="4" animationDuration=".9s" />
                    </div>
                ) : (
                    <>
                        <div className="rootDetail" style={{ color: 'black', paddingBottom: '10px' }}><span style={{ fontWeight: '600', }}>Created time :</span> {formatDate(rootDetailsRes.created_time)}</div>
                        <div className="rootDetail" style={{ color: 'black', paddingBottom: '10px' }}><span style={{ fontWeight: '600', }}>Disputed amount : </span>{rootDetailsRes.disputed_amount}</div>
                        <div className="rootDetail" style={{ color: 'black', paddingBottom: '10px' }}><span style={{ fontWeight: '600', }}>Hold amount : </span>{rootDetailsRes.hold_amount}</div>
                        <div className="rootDetail" style={{ color: 'black', paddingBottom: '20px' }}><span style={{ fontWeight: '600', }}>Job Id : </span>{rootDetailsRes.job_id}</div>

                        {mainMessage ? (
                            <div> {mainMessage}</div>
                        ) :
                            <DataTable
                                value={detailData}
                                responsiveLayout="scroll"
                                stripedRows
                                showGridlines
                            >
                                {detailData.length > 0 &&
                                    Object.keys(detailData[0]).map((key) => (
                                        <Column
                                            key={key}
                                            field={key}
                                            header={formatHeader(key)}
                                            style={{ minWidth: "200px" }}
                                        />
                                    ))}
                            </DataTable>
                        }
                    </>
                )}

                <div style={{ textAlign: "right", marginTop: 20 }}>
                    <Button
                        label="Close"
                        icon="pi pi-times"
                        onClick={() => {
                            setDisplayDialog(false);
                            setSelectedAckNo(null);
                        }}
                    />
                </div>
            </Dialog>
        </div>
    );
}
